import React, { useState } from "react";
import VisaSubclassStep from "./components/VisaSubclassStep";
import QuestionStep from "./components/QuestionStep";
import ProgressBar from "./components/ProgressBar";
import { visaQuestionMap } from "./utils/visaQuestionMap";
import { calculateTotalPoints } from "./utils/pointsCalculator";
import { transformAnswersForApi } from "./utils/answerTransformer";

const APPLYON_API_URL = "https://applyon.com.au/master/api/";

function App() {
  /**
   * step = 0  → Visa selection
   * step > 0  → Question index (1-based)
   */
  
  const [step, setStep] = useState(0);

  // Selected visa type (1–5)
  const [visaType, setVisaType] = useState(null);

  // Loaded questions from JSON
  const [questions, setQuestions] = useState([]);

  /**
   * Answers structure:
   * {
   *   [questionId]: { id, answer, score }
   * }
   */
  const [answers, setAnswers] = useState({});

  // Current question based on step
  const currentQuestion =
    step > 0 && step <= questions.length
      ? questions[step - 1]
      : null;

  // Total points
  const totalPoints = calculateTotalPoints(answers);

  // When visa is selected → load correct JSON
  const handleVisaNext = () => {
    const visaQuestions = visaQuestionMap[visaType];

    if (!visaQuestions) {
      alert("Invalid visa selection");
      return;
    }

    setQuestions(visaQuestions);
    setAnswers({});
    setStep(1);
  };

  // Save answer for a question
  const handleAnswerChange = (questionId, answer) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: { ...answer }
    }));
  };

  // 🔥 EXTERNAL API CALL (ONLY ON LAST QUESTION)
  const handleFinish = async () => {
  const answerPayload = transformAnswersForApi(
    questions,
    answers
  );

  const payload = {
    visaType,
    totalPoints,
    answers: answerPayload
  };

  console.log("Submitting payload to API:", payload);

  /*const response = await fetch(
    `${APPLYON_API_URL}submit-points`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }
  );

  if (!response.ok) {
    throw new Error("API request failed");
  }*/

  // Optional: read response
  // const data = await response.json();

  setStep(questions.length + 1);
};

  const stepLabels = questions.map((q) => q.title);

  return (
    <div>
      {/* Progress Bar */}
      {step > 0 && (
        <ProgressBar
          steps={stepLabels}
          currentStep={step}
        />
      )}

      {/* STEP 0: VISA SELECTION */}
      {step === 0 && (
        <VisaSubclassStep
          value={visaType}
          onChange={setVisaType}
          onNext={handleVisaNext}
        />
      )}

      {/* QUESTIONS FLOW */}
      {currentQuestion && (
        <QuestionStep
          question={currentQuestion}
          value={answers[currentQuestion.id]}
          onChange={(ans) =>
            handleAnswerChange(currentQuestion.id, ans)
          }
          onBack={() => setStep(step - 1)}
          onNext={() => setStep(step + 1)}
          isLast={step === questions.length}
          onFinish={handleFinish}
        />
      )}

      {/* LIVE POINTS (ONLY DURING QUESTIONS) */}
      {step > 0 && step <= questions.length && (
        <div className="points-preview">
          Total Points: {totalPoints}
        </div>
      )}

      {/* FINAL SUMMARY */}
      {step > questions.length && (
        <section className="result-wrapper">
          <div className="result-score">
            <div className="score-number">{totalPoints}</div>
            <div className="score-label">Total Points</div>
          </div>

          <div className="result-breakdown">
            {questions.map((q) => (
              <div key={q.id} className="breakdown-row">
                <div className="breakdown-title">
                  {q.title}
                </div>
                <div className="breakdown-points">
                  {answers[q.id]?.score || 0} pts
                </div>
              </div>
            ))}
          </div>

          <button
            className="restart-btn"
            onClick={() => setStep(0)}
          >
            Start Again
          </button>
        </section>
      )}
    </div>
  );
}

export default App;
